import React, { useEffect, useState } from "react"
import { ScrollView, TextInput, View } from "react-native"
import { ActivityIndicator, IconButton } from "react-native-paper"
import { connect } from "react-redux"
import { apiIdle, apiRequest } from "../../data/redux/actions/api"
import { liveReportService } from "../../data/services/liveReportService"
import FilledButtonM from "../components/button/FilledButtonM"
import { ModalM } from "../components/modal/ModalM"
import TextM from "../components/text/TextM"
import { theme } from "../theme/theme"
import { formatDateNumeric } from "../../data/utility/Utils"

const DiagnosticModal = (props) => {
    const { visible, onDismiss, liveReports, student, editable = false } = props

    // liveReports is always an array
    const reports = liveReports || []
    const hasMultipleReports = reports.length > 1

    // State for current report index when navigating through multiple reports
    const [currentReportIndex, setCurrentReportIndex] = useState(0)

    // Get current live report based on index
    const currentLiveReport = reports[currentReportIndex] || reports[0]

    const diagnosticData = props.diagnostics?.find(
        (d) => d.live_report_id === currentLiveReport?.id
    )

    const [editedDiagnostic, setEditedDiagnostic] = useState(
        diagnosticData?.diagnostic || ""
    )

    useEffect(() => {
        setEditedDiagnostic(diagnosticData?.diagnostic || "")
    }, [diagnosticData])

    // Reset to first report when modal opens
    useEffect(() => {
        if (visible) {
            setCurrentReportIndex(0)
        }
    }, [visible])

    const handleSave = () => {
        if (!editable) {
            return
        }

        props.apiRequest(
            liveReportService.setStudentDiagnostic,
            {
                id: currentLiveReport?.id,
            },
            {
                diagnostic: editedDiagnostic,
            }
        )
        onDismiss()
    }

    const handlePrevious = () => {
        if (currentReportIndex > 0) {
            setCurrentReportIndex(currentReportIndex - 1)
        }
    }

    const handleNext = () => {
        if (currentReportIndex < reports.length - 1) {
            setCurrentReportIndex(currentReportIndex + 1)
        }
    }

    const isLoading =
        props.generateDiagnosticDataRequest && !diagnosticData?.diagnostic

    return (
        <ModalM
            visible={visible}
            onDismiss={() => {
                onDismiss()
                handleSave()
            }}
            withExitButton={true}
            style={{
                padding: 20,
                height: "80%",
            }}
        >
            <View style={{ flex: 1, justifyContent: "space-between" }}>
                <View
                    style={{
                        alignItems: "center",
                        marginBottom: 20,
                    }}
                >
                    <View
                        style={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <TextM
                            fontSize={20}
                            fontWeight="Bold"
                            color={theme.colors.primary}
                            style={{ textAlign: "center" }}
                        >
                            Diagnostic pédagogique
                        </TextM>
                        <TextM
                            fontSize={14}
                            fontWeight="SemiBold"
                            color={theme.colors.primary}
                            style={{ textAlign: "center", marginTop: 5 }}
                        >
                            {student?.display_name}
                        </TextM>
                    </View>
                    {hasMultipleReports && (
                        <TextM
                            fontSize={14}
                            color={theme.colors.grey}
                            style={{ textAlign: "center", marginTop: 5 }}
                        >
                            {formatDateNumeric(currentLiveReport?.created_at)} (
                            {currentReportIndex + 1}/{reports.length})
                        </TextM>
                    )}
                </View>

                {isLoading && (
                    <View style={{ alignItems: "center", paddingVertical: 40 }}>
                        <ActivityIndicator
                            size="large"
                            color={theme.colors.primary}
                            style={{ marginBottom: 20 }}
                        />
                        <TextM
                            fontSize={16}
                            color={theme.colors.grey}
                            style={{ textAlign: "center" }}
                        >
                            Génération du diagnostic en cours...
                        </TextM>
                    </View>
                )}

                {!isLoading && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "stretch",
                            flex: 1,
                            gap: 10,
                        }}
                    >
                        {hasMultipleReports && (
                            <View style={{ justifyContent: "center" }}>
                                <IconButton
                                    size={32}
                                    icon="angle-left"
                                    disabled={currentReportIndex === 0}
                                    iconColor={theme.colors.primary}
                                    containerColor={theme.colors.transparent}
                                    onPress={handlePrevious}
                                    style={{ margin: 0 }}
                                />
                            </View>
                        )}

                        <View style={{ flex: 1 }}>
                            {editable ? (
                                <TextInput
                                    placeholder="Diagnostic de l'élève..."
                                    value={editedDiagnostic}
                                    style={{
                                        flex: 1,
                                        backgroundColor: theme.colors.white,
                                        borderWidth: 1,
                                        borderColor: theme.colors.light,
                                        borderRadius: theme.roundness,
                                        padding: 10,
                                        fontFamily: "Montserrat-Regular",
                                        fontSize: 14,
                                    }}
                                    multiline={true}
                                    numberOfLines={10}
                                    onChangeText={setEditedDiagnostic}
                                    placeholderTextColor={theme.colors.light}
                                    editable={editable}
                                />
                            ) : (
                                <ScrollView
                                    style={{
                                        backgroundColor: theme.colors.white,
                                        borderWidth: 1,
                                        borderColor: theme.colors.light,
                                        borderRadius: theme.roundness,
                                        padding: 10,
                                    }}
                                    contentContainerStyle={{
                                        flexGrow: 1,
                                        paddingBottom: 10,
                                    }}
                                >
                                    <TextM
                                        fontSize={14}
                                        fontWeight="Regular"
                                        color={
                                            editedDiagnostic
                                                ? theme.colors.grey
                                                : theme.colors.light
                                        }
                                        style={{
                                            fontFamily: "Montserrat-Regular",
                                        }}
                                        wrap
                                    >
                                        {editedDiagnostic ||
                                            "Diagnostic de l'élève..."}
                                    </TextM>
                                </ScrollView>
                            )}
                            {editable && (
                                <FilledButtonM
                                    label="Sauvegarder"
                                    onPress={handleSave}
                                    style={{
                                        marginHorizontal: 10,
                                        marginTop: 10,
                                    }}
                                />
                            )}
                        </View>

                        {hasMultipleReports && (
                            <View style={{ justifyContent: "center" }}>
                                <IconButton
                                    size={32}
                                    icon="angle-right"
                                    disabled={
                                        currentReportIndex ===
                                        reports.length - 1
                                    }
                                    iconColor={theme.colors.primary}
                                    containerColor={theme.colors.transparent}
                                    onPress={handleNext}
                                    style={{ margin: 0 }}
                                />
                            </View>
                        )}
                    </View>
                )}
            </View>
        </ModalM>
    )
}

const mapStateToProps = (state) => {
    return {
        generateDiagnosticDataRequest: state.api.setStudentDiagnostic?.request,
        generateDiagnosticData: state.api.setStudentDiagnostic,
        diagnostics: state.data.liveReports.diagnostics,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosticModal)
